import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export default function forgetPasswordModel() {
  const forgetPassword = reactive({
    api: apiEndpoint.bcrm_platform + "/account/ForgetPassword",
    method: "POST",
    payload: {
      brand_ref: "BL6ZLW8PXBXA",
      email: "sapanwadee.ko@chococrm.com",
    },
  });

  const passwordRecovery = reactive({
    api: apiEndpoint.bcrm_platform + "/account/PasswordRecovery",
    method: "POST",
    payload: {
      token: null,
      tx_reference: "",
      new_password: "",
    },
  });

  return {
    forgetPassword,
    passwordRecovery,
  };
}
